import { MetricValueDTO } from '@inversor-hub/types';

/**
 * A metric's number, or null when either the metric or the optional block
 * holding it is absent.
 *
 * `MetricValueDTO.value` is always `number | null`, but reading it through an
 * optional block (`actualAnnualized?.cashNoi.value`) also yields `undefined`.
 * Checking that inline is easy to get wrong: `?.value === null` is false for a
 * missing block while `?.value !== null` is true, so the two read as opposites
 * but disagree. Collapse both to null here and compare against null once.
 */
export const metricValue = (metric: MetricValueDTO | null | undefined): number | null =>
  metric?.value ?? null;

/** Sum of several metric numbers, or null when any of them is missing. */
export const sumMetricValues = (...values: (number | null)[]): number | null => {
  let total = 0;

  for (const value of values) {
    if (value === null) return null;
    total += value;
  }

  return total;
};
